import {
  REPORTS_LIST_REQUEST,
  REPORTS_LIST_RECEIVED,
  REPORTS_LIST_ERROR,
  REPORTS_LIST_CLEAR_FILTERS,
  REPORTS_LIST_SET_FILTERS,
  REPORTS_LIST_SET_PAGE,
  REPORT_SINGLE_DELETE_REQUEST,
  REPORT_SINGLE_DELETE_SUCCESS,
} from '../constants';
import { requests } from '../../helper/agent';
import * as API_ROUTES from '../../routing/api';
import { userLogout } from './user';
import { SubmissionError } from 'redux-form/lib/SubmissionError';
import { parseApiErrors } from '../../helper/apiUtils';

export const reportsListRequest = () => ({
  type: REPORTS_LIST_REQUEST,
});

export const reportsListReceived = (data) => ({
  type: REPORTS_LIST_RECEIVED,
  data,
});

export const reportsListError = (error) => ({
  type: REPORTS_LIST_ERROR,
  error,
});

export const reportsListSetPage = (page) => ({
  type: REPORTS_LIST_SET_PAGE,
  page,
});

export const reportsListSetFilters = (filters) => ({
  type: REPORTS_LIST_SET_FILTERS,
  filters,
});

export const reportsListClearFilters = () => ({
  type: REPORTS_LIST_CLEAR_FILTERS,
});

export const reportsListFetch = (page = 1, filters = {}) => {
  return (dispatch) => {
    dispatch(reportsListRequest());
    //console.log('Fetching reports ...');
    filters.page = page;
    if (filters.pagination === undefined) {
      filters.pagination = true;
    }
    return requests
      .get(`${API_ROUTES.REPORTS}`, filters)
      .then((response) => dispatch(reportsListReceived(response)))
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
        }
        dispatch(reportsListError(error));
      });
  };
};

export const reportSingleDeleteRequest = () => ({
  type: REPORT_SINGLE_DELETE_REQUEST,
});

export const reportSingleDeleteSuccess = (id) => ({
  type: REPORT_SINGLE_DELETE_SUCCESS,
  id,
});

export const reportSingleDelete = (reportId) => {
  //  console.log('Attempting to delete report ', reportId);
  return (dispatch) => {
    //    console.log('Attempting to dispatch reportSingleDeleteRequest');
    dispatch(reportSingleDeleteRequest());
    return requests
      .delete(`${API_ROUTES.REPORTS}/${reportId}`)
      .then(() => dispatch(reportSingleDeleteSuccess(reportId)))
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
        }
        throw new SubmissionError(parseApiErrors(error));
      });
  };
};

//
//// REPORTS_SINGLE
//
//export const rEPORTSingleRequest = () => ({
//  type: REPORTS_SINGLE_REQUEST,
//});
//
//export const rEPORTSingleReceived = (data) => ({
//  type: REPORTS_SINGLE_RECEIVED,
//  data,
//});
//
//export const rEPORTSingleError = (error) => ({
//  type: REPORTS_SINGLE_ERROR,
//  error,
//});
//
//export const rEPORTSingleFetch = (id) => {
//  return (dispatch) => {
//    dispatch(rEPORTSingleRequest());
//    console.log('Fetching single reports ...');
//    return requests.get(`${API_ROUTES.REPORT_BATCHES}/${id}`)
//        .then(response => dispatch(rEPORTSingleReceived(response)))
//        .catch(error => {
//      if (error.response && error.response.status === 401) {
//        return dispatch(userLogout());
//      } else if (error.response && error.response.status === 403) {
//        return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
//      }
//      dispatch(rEPORTSingleError(error));
//    });
//  };
//};
//
//export const rEPORTSingleUpdateRequest = () => ({
//  type: REPORTS_SINGLE_UPDATE_REQUEST,
//});
//
//export const rEPORTSingleUpdated = (data) => ({
//  type: REPORTS_SINGLE_UPDATED,
//  data,
//});
//
//export const rEPORTSingleUpdate = (data, reportsId) => {
//  return (dispatch) => {
//    dispatch(rEPORTSingleUpdateRequest());
//    return requests.patch(`${API_ROUTES.REPORT_BATCHES}/${reportsId}`, data)
//        .then(response => dispatch(rEPORTSingleUpdated(response)))
//        .catch(error => {
//      if (error.response && error.response.status === 401) {
//        return dispatch(userLogout());
//      } else if (error.response && error.response.status === 403) {
//        return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
//      }
//      throw new SubmissionError(parseApiErrors(error));
//    });
//  };
//};
